/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Remove Wundo?" |
*
* @param {Meeting_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_remove_title = /** @type {((inputs?: Meeting_Remove_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Remove_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo verwijderen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer Wundo ?")
	return /** @type {LocalizedString} */ ("Remove Wundo?")
});